<div class="progress" role="progressbar" [attr.aria-valuenow]="value" [attr.aria-valuemin]="0" [attr.aria-valuemax]="max">
  <div class="progress-bar bg-success" [style.width.%]="percent">
    <span class="px-2">{{ label || (value + ' / ' + max) }}</span>
  </div>
</div>
